import type { CreateCampaignInput } from '~/types/graphql';

import {
  CAMPAIGN_PRIORITY,
  CAMPAIGN_STATUS,
  CAMPAIGN_TYPE,
  DEFAULT_SETTING_TARGET,
} from '~/constants/campaign';

export const URL_REDIRECT_EXPERIMENT_NAME = 'URL experiment';

/** What a variant reads as in listings before a page has been picked for it. */
export const EMPTY_VARIANT_URL_LABEL = 'Choose page';

/**
 * How long a live-title lookup is considered fresh before a window refocus re-fetches it. Short
 * enough to pick up a rename made while the merchant was away, long enough that rapid tab-switching
 * doesn't refire 4 queries (product/page/collection/article) every time.
 */
export const VARIANT_URL_LIVE_TITLE_STALE_TIME_MS = 60_000;

export const URL_REDIRECT_CAMPAIGN_PRESET: CreateCampaignInput = {
  name: '',
  status: CAMPAIGN_STATUS.DRAFT,
  priority: CAMPAIGN_PRIORITY.CONVERSION,
  type: CAMPAIGN_TYPE.URL,
  storeDomain: '',
  targetCountries: DEFAULT_SETTING_TARGET,
  targetDevices: DEFAULT_SETTING_TARGET,
  targetChannels: DEFAULT_SETTING_TARGET,
  targetVisitorTypes: DEFAULT_SETTING_TARGET,
};
